<template>
  <el-select
    :value="vnodeId"
    class="pb-3"
    placeholder="choose a popup"
    @input="(value) => change(value)"
  >
    <el-option
      v-for="(popup, idx) in popupListData"
      :key="idx"
      :label="fmtName(popup, idx + 1)"
      :value="popup"
    >
    </el-option>
  </el-select>
</template>

<script>
import { mapActions } from 'vuex'
import * as actions from '../../store/modules/actions'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      popupListData: [],
      // value: this.selectedOption.name,
    }
  },
  computed: {
    popupList: {
      get() {
        return this.popupListData
      },
      set(data) {
        this.popupListData = data
      },
    },
    vnodeId: {
      get() {
        return this.value.name
      },
      set(id) {
        // eslint-disable-next-line vue/no-mutating-props
        this.value = id
      },
    },
  },
  created() {
    let ret = this.popups()
    ret
      .then((popup) => {
        if (popup) {
          let modified = []
          for (let i = 0; i < popup.length; i++) {
            if (popup[i] !== undefined) {
              modified.push({
                name: `popup ${i}`,
                popupVNode: popup[i].data.props.vnodeId,
                index: i,
              })
            }
          }
          this.popupList = modified
        }
        // console.log("PopupList: ", this.popupList)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    ...mapActions({
      popups: actions.POPUP_GET_LIST,
    }),
    fmtName(popup, idx) {
      // console.log("Popup with index: ", popup, idx)
      return popup.name || `Popup ${idx}`
    },
    change(e) {
      this.vnodeId = e
      this.$emit('change', e)
    },
  },
}
</script>
